
export async function importByEvent(
  this: Vue & { eventId?: number },
  feature: string
) {
  if (!this.eventId) {
    await new Promise(resolve => {
      const unwatch = this.$watch("eventId", () => {
        if (this.eventId) resolve(null);
        unwatch();
      });
    });
  }
  /* webpackMode: "lazy" */
  return (await import(`@/${feature}/${this.eventId}`)).default;
}
